import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 13 13",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M.929.929a.928.928 0 1 0 0 1.857H12.07a.928.928 0 1 0 0-1.857H.93Zm3.714 4.643a.928.928 0 1 0 0 1.857h7.428a.928.928 0 1 0 0-1.857H4.643Zm-.929 5.571c0 .514.415.929.929.929h7.428a.928.928 0 1 0 0-1.858H4.643a.928.928 0 0 0-.929.929ZM.93 5.572A.928.928 0 0 0 0 6.5v4.643a.928.928 0 1 0 1.857 0V6.5a.928.928 0 0 0-.928-.928Z"
	})
});
export default SvgIconAdd;
